import format from 'date-fns/format';
import getYear from 'date-fns/getYear';
import { changeTimeZone, formatFilterDateRange } from '../../../../../helpers';

const MAX_VALUE_YEAR = 9999;
const MIN_VALUE_YEAR = 1970;
export const MAX_VALUE_DATE = `${MAX_VALUE_YEAR}-02-02`;
export const MIN_VALUE_DATE = `${MIN_VALUE_YEAR}-02-02`;

export const getStartEndDateFromFilter = (dateRange, timeZone = 'UTC') => {
  if (!dateRange) {
    return { startDate: null, endDate: null };
  }

  const [startUtcIsoString, endUtcIsoString] = dateRange.split(',');
  const convertedStartDate = changeTimeZone(startUtcIsoString, timeZone);
  const convertedEndDate = changeTimeZone(endUtcIsoString, timeZone);

  const endDate = getYear(convertedEndDate) < MAX_VALUE_YEAR ? convertedEndDate : null;

  const startDate = getYear(convertedStartDate) > MIN_VALUE_YEAR ? convertedStartDate : null;

  return { startDate, endDate };
};

export const updateFilterDateField =
  ({ key, updateFilters, timeZone = 'UTC' }) =>
  ([start, end]) => {
    if (start || end) {
      const startDate = start ? format(start, 'yyyy-MM-dd') : MIN_VALUE_DATE;
      const endDate = end ? format(end, 'yyyy-MM-dd') : MAX_VALUE_DATE;

      const dateRangeString = formatFilterDateRange({
        startDate,
        endDate,
        timeZone,
      });

      updateFilters(key, dateRangeString);
    } else {
      updateFilters(key, null);
    }
  };

export const getSelectedOptions = (values, options) => {
  const asArray = Array.isArray(values) ? values : [values];
  return options.filter(({ key }) => asArray.includes(key));
};

export const getUpdateFilters = (options) =>
  options ? options.map(({ key }) => ({ value: key })) : [];

export const getMultipleSelectFilter = (options) => options || [];

export const filterUsersArray = (users) => users.filter((user) => !!user.name);

/**
 * Immutably sorts an array of objects alphabetically by name
 * @param arr - array of objects to sort
 */
export const sortAlphabeticallyByName = (arr) => {
  const sortedArray = [].concat(arr);

  return sortedArray.sort((a, b) => {
    const valueA = (a?.name ? a.name : '').toUpperCase();
    const valueB = (b?.name ? b.name : '').toUpperCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });
};
